<template>
  <div>
    <div class="page_title flex_between">
      <span>
        <span>成药审核详情</span>
        <span
          style="background-color: #ffecda; color: #f48a15"
          class="status"
          v-if="detail.reviewed_status == 1"
          >待审核</span
        >
        <span
          style="background-color: #e5f1e3; color: #669961"
          class="status"
          v-if="detail.reviewed_status == 2"
          >审核通过</span
        >
        <span
          style="background-color: #ffe4e4; color: #d76b59"
          class="status"
          v-if="detail.reviewed_status == 3"
          >审核不通过</span
        >
      </span>

      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div style="padding: 0 20px">
          <span class="itemtitle">提交日期：</span>
          <span>{{ detail.update_time }}</span>
        </div>
        <div
          style="width: 100%; height: 1px; background: #e8e9f0; margin: 16px 0"
        ></div>
        <div style="padding: 0 20px">
          <div class="itemtitle">药房信息</div>
          <div class="infobox">
            <div>
              <span style="display: inline-block; width: 300px">
                <span class="gray">药房名称：</span>
                <span class="black">{{ detail.hospital_name }}</span>
              </span>
              <span>
                <span class="gray">药房类型：</span>
                <span class="black">{{ detail.org_type }}</span>
              </span>
            </div>
            <div style="margin: 20px 0">
              <span style="display: inline-block; width: 300px">
                <span class="gray">纳税人识别号：</span>
                <span class="black">{{ detail.identification_number }}</span>
              </span>
              <span>
                <span class="gray">所在区域：</span>
                <span class="black">{{ detail.address }}</span>
              </span>
            </div>
          </div>
          <div class="itemtitle">成药信息</div>
          <div>
            <div class="infobox">
              <div style="margin-bottom: 20px">
                <span style="display: inline-block; width: 300px">
                  <span class="gray">成药编号：</span>
                  <span class="black">{{ detail.pm_code }}</span>
                </span>
                <span style="display: inline-block; width: 300px">
                  <span class="gray">成药名称：</span>
                  <span class="black">{{ detail.pm_name }}</span>
                </span>
                <span style="display: inline-block; width: 300px">
                  <span class="gray">规格：</span>
                  <span class="black"
                    >{{ detail.pm_spec }}&nbsp;{{
                      detail.total_measurement_units
                    }}&nbsp;{{ detail.min_unit_total_quantity }}</span
                  >
                </span>
                <span style="display: inline-block; width: 300px">
                  <span class="gray">单位：</span>
                  <span class="black">{{ detail.pm_unit }}</span>
                </span>
              </div>

              <div style="margin-bottom: 20px">
                <span style="display: inline-block; width: 300px">
                  <span class="gray">建议用量：</span>
                  <span class="black"
                    >{{ detail.default_use_level }} &nbsp;{{
                      detail.use_level_unit
                    }}</span
                  >
                </span>

                <span style="display: inline-block; width: 300px">
                  <span class="gray">服用频次：</span>
                  <span class="black">{{ detail.frequency_of_use }}</span>
                </span>

                <span style="display: inline-block; width: 300px">
                  <span class="gray">默认用法：</span>
                  <span class="black">{{ detail.default_use_method }}</span>
                </span>

                <span style="display: inline-block; width: 300px">
                  <span class="gray">贮藏：</span>
                  <span class="black">{{ detail.default_storage }}</span>
                </span>
              </div>

              <div>
                <span style="display: inline-block; width: 300px">
                  <span class="gray">成药分类：</span>
                  <span class="black" v-if="detail.pm_category == 1">西药</span>
                  <span class="black" v-if="detail.pm_category == 2"
                    >中成药</span
                  >
                </span>
                <span style="display: inline-block; width: 300px">
                  <span class="gray">疗效分类：</span>
                  <span class="black">{{ detail.category_name }}</span>
                </span>
                <span style="display: inline-block; width: 300px">
                  <span class="gray">成本价：</span>
                  <span class="black">{{ detail.cost_price }}</span>
                </span>
                <span style="display: inline-block; width: 300px">
                  <span class="gray">销售价：</span>
                  <span class="black">{{ detail.price }}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="itemtitle">说明书信息</div>
          <div>
            <div class="infobox">
              <div v-html="detail.content"></div>
            </div>
          </div>
          <div class="itemtitle">生产厂家</div>
          <div>
            <div class="infobox">
              <!-- 生产厂家： -->
              {{ detail.productor }}
            </div>
          </div>

          <div style="margin-top: 40px" v-if="detail.reviewed_status == 1">
            <el-button
              plain
              @click="examine(3)"
              style="width: 100px"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('96') : false
              "
              >不通过</el-button
            >
            <el-button
              type="primary"
              @click="examine(2)"
              style="width: 100px"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('96') : false
              "
              >通过</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import platform from "../../../api/platform";
import _ from "lodash";
export default {
  data() {
    return {
      business_license: "",
      drug_trade_license: "",
      gsp: "",
      id_card_face: "",
      id_card_side: "",
      detail: {},
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    //获取药品审核详情
    getReviewed() {
      let pm_id = this.$route.query.pm_id;
      this.axios
        .post("platform/TraditionDrug/getTraditionDrugAuthInfo", { pm_id })
        .then((res) => {
          if (res.code == 0) {
            this.detail = res.data.info;
            this.detail.update_time = platform.timestampToTime(
              this.detail.update_time
            );
          }
        });
    },

    //审核
    examine(status) {
      let pm_id = this.$route.query.pm_id;
      let auth_status = status;
      let text = "";
      if (status == 3) {
        text = "未通过";
      } else {
        text = "通过";
      }
      this.$confirm(`是否审核${text}？`, "审核", {
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.axios
            .post("platform/TraditionDrug/auditTraditionDrug", {
              pm_id,
              auth_status,
            })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success(`该成药审核${text}!`);
                this.back();
              }
            });
        })
        .catch();
    },
    back() {
      history.back();
    },
  },
  created() {
    this.getReviewed();
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  padding: 24px 0;
  box-sizing: border-box;
  background: #ffffff;
  min-width: 1000px;
  text-align: left;
  min-height: calc(100vh - 140px);
}

.black {
  color: #000;
}
.gray {
  color: #666;
  display: inline-block;
  text-align: right;
  width: 100px;
}
.itemtitle {
  color: #333;
  font-weight: 600;
  margin-bottom: 12px;
}
.infobox {
  height: 100%;
  border: solid 1px #cfcece;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 30px;
}
.imglist {
  padding-right: 40px;
  display: flex;
  justify-content: space-between;
  .imgitem {
    width: 200px;
    .imgbox {
      width: 200px;
      height: 140px;
      border: solid 1px #d6d6d6;
      padding: 10px;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .imgtext {
      color: #737982;
      font-weight: 600;
      margin-bottom: 8px;
    }
  }
}
.status {
  display: inline-block;
  border-radius: 2px;
  height: 20px;
  line-height: 20px;
  padding: 3px 8px;
  margin-left: 20px;
  font-size: 16px;
  font-weight: 400;
}
.pricebox {
  border: solid 1px #cfcece;
  height: 40px;
  line-height: 40px;
  border-top: 0px solid #fff;
  padding-left: 20px;
  box-sizing: border-box;
}
.drug {
  margin-bottom: 15px;
  margin-right: 30px;
  .s1 {
    width: 70px;
  }
}
</style>
